export default __webpack_public_path__ + "static/media/annotation.a993d5ab.svg";